import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { TMARPOLTank } from 'redux/app/marpol/@types';
import { IStore } from 'redux/store';

type OwnProps = {
    tanks: TMARPOLTank[];
    hidePositionCol?: boolean;
};
type TankWithPositionProps = PropsFromRedux & OwnProps;
function TankWithPosition(props: TankWithPositionProps) {
    const { tanks, hidePositionCol = false } = props;

    return (
        <table>
            <thead className="bg-gray-300">
                <tr className="">
                    <th className="p-1 border border-gray-500 min-w-48">
                        Identification of tanks
                    </th>
                    {!hidePositionCol ? (
                        <th className="p-1 border border-gray-500 min-w-32">
                            Position
                        </th>
                    ) : null}
                    <th className="p-1 border border-gray-500 min-w-32">
                        Capacity(m³)
                    </th>
                </tr>
            </thead>
            <tbody>
                {tanks.map((tank) => {
                    const { id, lateralPosition, totalCapacity } = tank;

                    return (
                        <tr key={id}>
                            <td className="p-0 px-1 border">
                                {tank?.tankName}
                            </td>
                            {!hidePositionCol ? (
                                <td className="p-0 px-1 border">
                                    {lateralPosition}
                                </td>
                            ) : null}
                            <td className="p-0 px-1 text-center border">
                                {totalCapacity}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(TankWithPosition);
